import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-factory-service',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './factory-service.component.html',
  styleUrl: './factory-service.component.scss'
})
export class FactoryServiceComponent {

}
